import withPageQuery from 'lib/withPageQuery';
import withAds from 'lib/withAds';
import withFlowLayout from 'lib/withFlowLayout';
import CollectionLayout from 'components/CollectionLayout';
import { HOME } from 'constants/pageTypes';

export default withPageQuery(withAds(withFlowLayout(CollectionLayout)), {
  type: HOME,
  fetchMoreLimit: 6
});
